import { Component, Input } from '@angular/core';
import { WebBadgeComponent } from '@app/components/humi-design-library/badge/badge.component';
import { HumiInquiryStatus } from '@app/models/kyc-kyb/types';
import { BadgeType } from '@humi-design-library/components/Badge/types';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    template: `
        @if (status) {
            <ui-badge [type]="BADGE_TYPE_MAPPING[status]">{{
                'payroll.kyc-kyb.statuses.' + status | translate
            }}</ui-badge>
        } @else {
            <ui-badge type="default">
                <div class="loadable loading"></div>
            </ui-badge>
        }
    `,
    selector: 'app-kyc-kyb-badge',
    styles: `
        :host {
            --spinner-overlay-color: transparent;
            --spinner-min-content-width: 14px;
            --spinner-size: 14px;
            --spinner-thickness: 3px;
        }

        .loadable {
            opacity: 0.5;
            min-width: 40px;
        }
    `,
    standalone: true,
    imports: [WebBadgeComponent, TranslateModule],
})
export class KYCKYBBadge {
    @Input() status?: HumiInquiryStatus;

    BADGE_TYPE_MAPPING: Record<HumiInquiryStatus, BadgeType> = {
        not_complete: 'danger',
        in_progress: 'warning',
        complete: 'success',
    };
}
